export const PreviousDoubleArrowIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M9.75 14.25L5.25 9L9.75 3.75" stroke="#3B3F5C" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
        <path opacity="0.5" d="M12.7499 14.25L8.24988 9L12.7499 3.75" stroke="#3B3F5C" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
}